$(function(){
  $('.truncated__trigger').on('click', function() {
    $venueDescription =$(this).prev();
    $venueDescriptionInner = $venueDescription.find('div')

    if ( ! $venueDescription.hasClass('truncated--show') ) {
        $venueDescription.addClass('truncated--show');
        $venueDescription.css('maxHeight', $venueDescriptionInner.height());
    $(this).text('閉じる');
    } else {
        $venueDescription.removeClass('truncated--show');
        $venueDescription.attr('style', '');
    $(this).text('もっと見る');
    }

    
  });
}); 

